import { ButtonHTMLAttributes } from 'react';

import styles from './PreselectButton.module.scss';
import { TPeriodType } from '../../types';

interface PreselectButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  value: TPeriodType;
}

export const PreselectButton = ({ type, value, children, ...props }: PreselectButtonProps) => (
  <button type="button" className={styles.preselectButton} value={value} {...props}>
    {children}
  </button>
);
